module.exports = __webpack_public_path__ + "img/null.d7baf585.png";